import { render, staticRenderFns } from "./UserBalanceBalancesFilters.vue?vue&type=template&id=8de4bdd2&"
import script from "./UserBalanceBalancesFilters.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalancesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports